<template>
	<div class="wrapper">
		<headerTag />
		<div class="twDiv twDiv2">
			<p>
				<img src="../../assets/images/user/wt_user.png" alt="" class="tsUser_img" />
				<span>{{content}}</span></br>
				<img :src="picUrl1" alt="" class="tsImg" v-if="picUrl1 !='' && picUrl1 != null" @click="imgMax($event)" />
				<img :src="picUrl2" alt="" class="tsImg" v-if="picUrl2 !='' && picUrl2 != null" @click="imgMax($event)" />
			</p>
			<p class="wtTime">
				<span>{{createDate}}</span>&nbsp;&nbsp;提交
			</p>
		</div>
		<div class="twDiv twDiv3">
			<p>{{status}}</p>
			<p>{{answer}}</p>
		</div>
		<footerTag />
		
		<!--展示大图-->
		<van-popup v-model="show" style="width: 100%; background: none;" @click="showNo">
			<img :src="imgSrc" alt="" style="width: 90%; margin-left: 5%; height: auto;" />
		</van-popup>
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
	import { Popup } from 'vant'
    
    export default {
    	name: 'tousuDetail',
    	props: {
        
    	},
    	data(){
		  return {
		    cid:'',
		    content:'',
		    createDate:'',
		    status:'',
		    answer:'',
		    picUrl1:'',
		    picUrl2:'',
			show:false,
			imgSrc:'',
		  }
		},
    	components: {
    		headerTag,
    		footerTag,
			[Popup.name]:Popup,
    	},
    	methods: {
				showNo(){
					this.show = false;
				},
				imgMax(e){
					 this.show = true;
					 this.imgSrc=e.target.getAttribute('src');
				},
				loadComplaintInfo(){
					this.axios({
					 	method: 'POST',
					 	url:'/feedback/getComplaintDetail',
						params:{
							cid:this.cid
					 	},
					}).then((res)=>{
							if(res.data.code==1000){
					 			let data = res.data.obj;
					 			this.content=data.content;
					 			this.createDate=data.createDate;
								this.status=data.status;
								this.answer=data.answer;
								if(data.picUrl1 !='' && data.picUrl1 != null){
									this.picUrl1=this.rootUrl+data.picUrl1;
								}else{
									this.picUrl1=data.picUrl1;
								}
								if(data.picUrl2 !='' && data.picUrl2 != null){
									this.picUrl2=this.rootUrl+data.picUrl2;
								}else{
									this.picUrl2=data.picUrl2;
								}
					 		}else if(res.data.code == 1110){
				  				//未登录
					  			let currPath=window.location.href;
					  			window.location.href='/login?targetUrl='+currPath;
				  			}else{
				  				this.$message.error({message: '网络异常，请稍后重试'});
			  				}
					}).catch((err)=>{
					 	this.$message.error({message: '获取数据失败'});
					})
				},
		},
    	created(){
			this.cid = this.$route.params.id;
			this.loadComplaintInfo();
		}
    }
</script>